import { gql, MutationHookOptions } from "@apollo/client"
import { useMutation } from "@oysterhr/core"
import { ConfirmMandateLodgingInput, ConfirmMandateLodgingPayload } from "@oysterhr/schema"

const PAYMENTS_CONFIRM_MANDATE_LODGING = gql`
  mutation ConfirmMandateLodging($mandateId: ID!) {
    confirmMandateLodging(input: { mandateId: $mandateId }) {
      mandate {
        id
        state
        signedDownloadUrl {
          url
        }
      }
      errors
    }
  }
`

export const useConfirmMandateLodging = (
  options?: MutationHookOptions<
    { confirmMandateLodging: ConfirmMandateLodgingPayload },
    ConfirmMandateLodgingInput
  >,
) => useMutation(PAYMENTS_CONFIRM_MANDATE_LODGING, options)
